export default __webpack_public_path__ + "static/23-d5d0e74fceb2f6a94931f51653b780c7.jpg";